import { useEffect } from "react";
import ProductCard from "./ProductCard";

export default function ConcernModal({ concern, onClose, onEnquirePackage }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [onClose]);

  if (!concern) return null;
  const recs = concern.recommended_products || [];
  const images = concern.images || [];

  return (
    <div className="modal-overlay open" onClick={(e) => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-hero">
          <button className="modal-close" onClick={onClose}>
            &times;
          </button>
          <div className="ic">
            <i className={`fa-solid ${concern.icon}`} />
          </div>
          <h2>{concern.title}</h2>
          <p>{concern.short}</p>
        </div>
        <div className="modal-body">
          {images.length > 0 && (
            <div className="concern-gallery">
              {images.map((src, i) => (
                <img key={i} src={src} alt={`${concern.title} ${i + 1}`} loading="lazy" />
              ))}
            </div>
          )}

          <h4>About this concern</h4>
          <p style={{ color: "var(--muted)" }}>{concern.about}</p>

          <h4>Helpful lifestyle tips</h4>
          <ul className="tips">
            {(concern.tips || []).map((t, i) => (
              <li key={i}>
                <i className="fa-solid fa-check" /> {t}
              </li>
            ))}
          </ul>

          <h4>Recommended natural products</h4>
          {recs.length ? (
            <div className="modal-products">
              {recs.map((p) => (
                <ProductCard key={p.id} product={p} />
              ))}
            </div>
          ) : (
            <p style={{ color: "var(--muted)" }}>Browse our full catalogue below.</p>
          )}

          {concern.package && (
            <>
              <h4>Suggested care package</h4>
              <div className="rec-pkg">
                <div>
                  <b>{concern.package}</b>
                  <p>A curated bundle built around this concern.</p>
                </div>
                <button className="btn btn-gold" onClick={() => onEnquirePackage(concern.package)}>
                  <i className="fa-brands fa-whatsapp" /> Enquire
                </button>
              </div>
            </>
          )}

          <p
            style={{
              fontSize: ".78rem",
              color: "var(--muted)",
              marginTop: "22px",
              borderTop: "1px solid var(--line)",
              paddingTop: "14px",
            }}
          >
            <i className="fa-solid fa-circle-info" style={{ color: "var(--leaf)" }} /> This information is for general
            wellness guidance only and is not medical advice. Please consult a healthcare professional for diagnosis or
            treatment.
          </p>
        </div>
      </div>
    </div>
  );
}
